import { FormControl, InputLabel } from '@mui/material';
import React from 'react';

interface DatePickerProps {
  id?: string;
  label: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  fullWidth?: boolean;
  required?: boolean;
}

/**
 * Custom DatePicker component
 * Date selection component that matches Material-UI styling
 */
export const DatePicker: React.FC<DatePickerProps> = ({
  id,
  label,
  value,
  onChange,
  fullWidth = false,
  required = false,
}) => {
  return (
    <FormControl sx={{ minWidth: 200, width: fullWidth ? '100%' : 'auto' }} required={required}>
      <InputLabel
        shrink
        htmlFor={id || 'date-input'}
        sx={{
          position: 'absolute',
          transform: 'translate(14px, -9px) scale(0.75)',
          transformOrigin: 'top left',
        }}
      >
        {label}
      </InputLabel>
      <input
        id={id || 'date-input'}
        type="date"
        value={value ? value.toISOString().split('T')[0] : ''}
        onChange={(e) => onChange(e.target.value ? new Date(e.target.value) : null)}
        style={{
          padding: '16.5px 14px',
          borderRadius: '4px',
          border: '1px solid rgba(0, 0, 0, 0.23)',
          width: '100%',
          height: '56px',
          boxSizing: 'border-box',
          fontSize: '1rem',
          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        }}
        required={required}
      />
    </FormControl>
  );
};

export default DatePicker;
